import { getLocale } from '../dependencies';

export const compareWithLocale = (reference: string, compare: string) => {
	const locale = getLocale();
	return reference.localeCompare(compare, locale);
};
